import * as u from "react";
import s from "./chunk901.js";
import { jsx as i } from "react/jsx-runtime";
import p from "./chunk1144.js";
const c = /* @__PURE__ */ u.createContext(void 0);
function f({
  value: o,
  children: e
}) {
  return /* @__PURE__ */ i(c.Provider, {
    value: o,
    children: e
  });
}
process.env.NODE_ENV !== "production" && (f.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * @ignore
   */
  value: s.object
});
function m(o) {
  const {
    theme: e,
    name: t,
    props: n
  } = o;
  if (!e || !e.components || !e.components[t])
    return n;
  const r = e.components[t];
  return r.defaultProps ? p(r.defaultProps, n) : !r.styleOverrides && !r.variants ? p(r, n) : n;
}
function P({
  props: o,
  name: e
}) {
  const t = u.useContext(c);
  return m({
    props: o,
    name: e,
    theme: {
      components: t
    }
  });
}
export {
  f as default,
  P as useDefaultProps
};
